//Config file for 2026 season rebuild for individual uploads. its set as year 8888

/**
 * The different writeTypes:
 *      bool: boolean value
 *      inc: a timer
 *      tog: toggles a timer that gets added to an array
 *      cycG: cycles through numerical options
 *      int: integer value
 *      popup: triggers a popup
 *          does not have automatic functions, is a special key that needs further work in scout.js
 * 
 * 
 *  Note: i also added a new key called multipler. its exclusivly for this year for the x5, x10, x1 additions to the datapoint
 * 
 * Just a little note
 * event_path is hardcoded in both tabs/Home and components/Eventinput
 * scout_team is hardcoded in tabs/Home
 * allaince_color is hardcoded in both tabs/Home and tabs/Scout (for the post match section)
 * 
 * basically dont mess with any of the "start" section datapoints bc it might screw with something somewhere
 * that goes for the ones in initialPage and startScoutPage as well
 * anything else is fair game to change
 */
export const gridSettings8888 = {
    "auto": {
        "rc": 4
    },
    "tele": {
        "rc": 4
    }
}

// Auto field crossing rules for 2026 count mode (8888).
// A path crossing near any x value in crossX can trigger y-range mappings below.
export const fieldCrossing8888 = {
    "crossX": [29, 71],
    "xTolerance": 1.25,
    "crossYMappings": [
        {
            "targetKey": "cross_trench",
            "crossedValue": true,
            "defaultValue": false,
            "yRanges": [[1, 11], [41, 50]]
        },
        {
            "targetKey": "cross_bump",
            "crossedValue": true,
            "defaultValue": false,
            "yRanges": [[13, 22], [31, 40]]
        }
    ]
}

export const mainSettings8888 = {
    "NAmessage": {
        "autoAccuracy" : "Your robot has Auto scoring, but you left accuracy blank. Proceed, or go back and fix?",
        "teleAccuracy" : "Your robot has Tele scoring, but you left accuracy blank. Proceed, or go back and fix?",
        "field" : "Your robot is on the field, but you left its auto path blank. Proceed, or go back and fix?",
        "bumpTrench" : "Your robot has fed/shot fuel, but both crossing bump and trench are false. Proceed, or go back and fix?",
    },
    "notApplicables": {
        "autoAccuracy" : "dataMap.get('auto_accuracy') == 'N/A' && dataMap.get('auto_scoring') > 0",
        "teleAccuracy" : "dataMap.get('tele_accuracy') == 'N/A' && dataMap.get('tele_scoring') > 0",
        "field" : "(dataMap.get('auto_field') == undefined || dataMap.get('auto_field').length == 0) && (dataMap.get('cross_bump') == true || dataMap.get('cross_trench') == true || (dataMap.get('auto_scoring') + dataMap.get('tele_scoring')) > 0 || (dataMap.get('auto_feeding') + dataMap.get('tele_feeding')) > 0)",
        "bumpTrench" : "dataMap.get('cross_bump') == false && dataMap.get('cross_trench') == false && dataMap.get('auto_scoring') + dataMap.get('tele_scoring') > 8 || dataMap.get('cross_bump') == false && dataMap.get('cross_trench') == false && dataMap.get('auto_feeding') + dataMap.get('tele_feeding') > 0",
    },
    "imported": {
        "groupSharedLabels": true
    },
    "auto": [
        {
            "label": "auto_field",
            "display": "🏁 Field",
            "trigger": "m",
            "columnStart": 1,
            "columnEnd": 5,
            "rowStart": 3,
            "rowEnd": 5,
            "writeType": "popup",
        },
        {
            "label": "auto_scoring",
            "ui_id": "auto_scoring_x1",
            "display": "🟡 Shot x1",
            "trigger": "q",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 1,
            "rowEnd": 2,
            "multiplier": 1,
            "writeType": "int"
        },
        {
            "label": "auto_scoring",
            "ui_id": "auto_scoring_x5",
            "display": "🟡 Shot x5",
            "trigger": "w",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 1,
            "rowEnd": 2,
            "multiplier": 5,
            "writeType": "int"
        },
        {
            "label": "auto_scoring",
            "ui_id": "auto_scoring_x10",
            "display": "🟡 Shot x10",
            "trigger": "e",
            "columnStart": 3,
            "columnEnd": 4,
            "rowStart": 1,
            "rowEnd": 2,
            "multiplier": 10,
            "writeType": "int"
        },
        {
            "label": "auto_feeding",
            "ui_id": "auto_feeding_x1",
            "display": "🥄 Feeding x1",
            "trigger": "i",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 2,
            "rowEnd": 3,
            "multiplier": 1,
            "writeType": "int"
        },
        {
            "label": "auto_feeding",
            "ui_id": "auto_feeding_x5",
            "display": "🥄 Feeding x5",
            "trigger": "o",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 2,
            "rowEnd": 3,
            "multiplier": 5,
            "writeType": "int"
        },
        {
            "label": "auto_feeding",
            "ui_id": "auto_feeding_x10",
            "display": "🥄 Feeding x10",
            "trigger": "p",
            "columnStart": 3,
            "columnEnd": 4,
            "rowStart": 2,
            "rowEnd": 3,
            "multiplier": 10,
            "writeType": "int"
        },
        {
            "label": "auto_accuracy",
            "display": "🎯 Accuracy",
            "trigger": "c",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "cycG",
            "cycGOptions": ["N/A", 1.0, 0.95, 0.9, 0.85, 0.8, 0.75, 0.7, 0.65, 0.6, 0.55, 0.5, 0.45, 0.4, 0.35, 0.3, 0.25, 0.2, 0.15, 0.1, 0.05, 0]
        },
        {
            "label": "auto_climb",
            "display": "🪜 Climb Level",
            "trigger": "v",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "cycG",
            "cycGOptions": [0, 15]
        }
    ],
    "tele": [
        {
            "label": "tele_scoring",
            "ui_id": "tele_scoring_x1",
            "display": "🟡 Shot x1",
            "trigger": "q",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 1,
            "rowEnd": 2,
            "multiplier": 1,
            "writeType": "int"
        },
        {
            "label": "tele_scoring",
            "ui_id": "tele_scoring_x5",
            "display": "🟡 Shot x5",
            "trigger": "w",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 1,
            "rowEnd": 2,
            "multiplier": 5,
            "writeType": "int"
        },
        {
            "label": "tele_scoring",
            "ui_id": "tele_scoring_x10",
            "display": "🟡 Shot x10",
            "trigger": "e",
            "columnStart": 3,
            "columnEnd": 4,
            "rowStart": 1,
            "rowEnd": 2,
            "multiplier": 10,
            "writeType": "int"
        },
        {
            "label": "tele_feeding",
            "ui_id": "tele_feeding_x1",
            "display": "🥄 Feeding x1",
            "trigger": "i",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 2,
            "rowEnd": 3,
            "multiplier":1,
            "writeType": "int"
        },
        {
            "label": "tele_feeding",
            "ui_id": "tele_feeding_x5",
            "display": "🥄 Feeding x5",
            "trigger": "o",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 2,
            "rowEnd": 3,
            "multiplier":5,
            "writeType": "int"
        },
        {
            "label": "tele_feeding",
            "ui_id": "tele_feeding_x10",
            "display": "🥄 Feeding x10",
            "trigger": "p",
            "columnStart": 3,
            "columnEnd": 4,
            "rowStart": 2,
            "rowEnd": 3,
            "multiplier":10,
            "writeType": "int"
        },
        {
            "label": "tele_accuracy",
            "display": "🎯 Accuracy",
            "trigger": "c",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "cycG",
            "cycGOptions": ["N/A", 1.0, 0.95, 0.9, 0.85, 0.8, 0.75, 0.7, 0.65, 0.6, 0.55, 0.5, 0.45, 0.4, 0.35, 0.3, 0.25, 0.2, 0.15, 0.1, 0.05, 0]
        },
        {
            "label": "defended_time",
            "display": "🛡️ Defended Time",
            "trigger": "t",
            "columnStart": 3,
            "columnEnd": 5,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "inc"
        },
        {
            "label": "attacking_time",
            "display": "⚔️ Attacking",
            "trigger": "r",
            "columnStart": 1,
            "columnEnd": 3,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "inc"
        },
        {
            "label": "oof_time",
            "display": "🚑 Oof Time",
            "trigger": "b",
            "columnStart": 3,
            "columnEnd": 5,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "inc"
        },
        {
            "label": "cross_bump",
            "display": "⛰️ Bump",
            "trigger": "f",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "bool"
        },
        {
            "label": "cross_trench",
            "display": "🧥 Trench",
            "trigger": "g",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "bool"
        },
        {
            "label": "tele_climb",
            "display": "🪜 Climb Level",
            "trigger": "v",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "cycG",
            "cycGOptions": [0, 10, 20, 30]

        },

    ],
    "after": [
        {
            "label": "auto_qata",
            "display": "Auto QATA",
            "writeType": "str",
            "placeholder": "e.g. speed? path? starting location?"
        },
        {
            "label": "qata",
            "display": "Tele QATA",
            "writeType": "str",
            "placeholder": "e.g. how are they scoring? speed? skill?"
        },
        {
            "label": "defense_qata",
            "display": "Defense QATA",
            "writeType": "str",
            "placeholder": "how did they play defense? push power? speed?"
        }
    ],
    "start": [
        {
            "label": "scout_id",
            "display": "Scout ID",
            "writeType": "str",
            "placeholder": "Your Name",
            "maxLength":"20"
        },
        {
            "label": "scout_team",
            "display": "Scout Team",
            "writeType": "int",
            "placeholder": "The scouter's team number",
            "maxLength":"13000"
        },
        {
            "label": "team_position",
            "display": "Team Position",
            "writeType": "int",
            "placeholder": "1, 2, or 3",
            "maxLength":"3"
        },
        {
            "label": "match_number",
            "display": "Match Number",
            "writeType": "int",
            "placeholder": "Current match #",
            "maxLength":"999"
        },
        {
            "label": "team_number",
            "display": "Team Number",
            "writeType": "int",
            "placeholder": "# of the team you are scouting",
            "maxLength":"13000"
        },
        {
            "label": "alliance_color",
            "display": "Alliance Color",
            "writeType": "str",
            "placeholder": "Click to Set Color",
            "maxLength":"4"
        }
    ]
}


export const rebuiltMissTypeCount8888 = {
    "auto": [
        {
            "label": "auto_miss",
            "display": "🎯 Miss",
            "trigger": "c",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "int",
        }
    ],
    "tele":[
        {
            "label": "tele_miss",
            "display": "🎯 Miss",
            "trigger": "c",
            "trigger": "c",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "int",
        }
    ]
}
